import { useState } from "react";
import { Link } from "react-router-dom";
import { Crown, ShieldCheck, BadgeCheck, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const DISMISS_KEY = "ocedogs_vip_strip_dismissed";

// Slim, dismissible invite for non-VIP members to subscribe on Patreon.
const VipPromoStrip = () => {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

  if (hidden || user?.is_patron) return null;

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setHidden(true); };

  return (
    <div data-testid="vip-promo-strip" className="relative border-b border-[#F96854]/30 bg-gradient-to-r from-[#F96854]/15 via-[#F96854]/5 to-transparent">
      <div className="max-w-[1600px] mx-auto px-4 lg:px-8 py-2.5 flex items-center gap-3">
        <Crown className="w-4 h-4 text-[#F96854] shrink-0" />
        <div className="flex-1 min-w-0 flex flex-wrap items-center gap-x-4 gap-y-1">
          <span className="font-stencil font-bold uppercase text-xs text-[#F1F5F9]">Become a VIP</span>
          <span className="hidden sm:inline-flex items-center gap-1.5 font-mono text-[11px] text-[#CBD5E1]"><ShieldCheck className="w-3.5 h-3.5 text-[#F96854]" /> Reserved server slot</span>
          <span className="hidden md:inline-flex items-center gap-1.5 font-mono text-[11px] text-[#CBD5E1]"><BadgeCheck className="w-3.5 h-3.5 text-[#F96854]" /> VIP badge on your profile &amp; the kill feed</span>
          <span className="hidden lg:inline font-mono text-[11px] text-[#94A3B8]">· Keep OCE DOGS online</span>
        </div>
        <Link to="/patreon" data-testid="vip-promo-strip-cta" className="shrink-0 inline-flex items-center gap-1.5 bg-[#F96854] hover:bg-[#fa7d6c] text-white font-stencil font-black uppercase text-[11px] px-3.5 py-1.5 tactical-frame-sm transition-colors">
          Subscribe to VIP
        </Link>
        <button onClick={dismiss} data-testid="vip-promo-strip-dismiss" aria-label="Dismiss" className="shrink-0 p-1 text-[#94A3B8] hover:text-[#F1F5F9]">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default VipPromoStrip;
